<mat-toolbar class="subtitulo">Planejamento das Atividades</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">
        <div class="painel-principal" style="padding: 10px;">
            <mat-tab-group>
                
                <!-- DADOS DA AÇÃO -->
                <mat-tab label="PLANO ATIVIDADE">
                    <form #formCadastroDadosAcao="ngForm">
                        <div ngModelGroup="comboAcoesPlanejamento">
                            <formulario-grupo-acao-oficina [grupoAcao]="grupoAcao" 
                                                           [perfilAcesso]="perfilAcesso"
                                                           [perfilAcessoAnalise]="perfilAcessoAnalise"
                                                           (grupoAcaoOutput)="updateGrupoAcao($event)">
                            </formulario-grupo-acao-oficina>
                        </div>
                    </form>
                </mat-tab>
        
                <!-- MATERIAIS DA AÇÃO -->
                <mat-tab label="MATERIAIS" *ngIf="false">
                    <!--
                    <form #formCadastroMateriaisAcao="ngForm">
                        <div ngModelGroup="comboMateriais">
                            <materiais-acoes [acao]="acoes"></materiais-acoes>
                        </div>
                    </form>
                    -->
                </mat-tab>
                
            </mat-tab-group>
        </div>
    </form>    


    <!-- BOTOES -->
    <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
        fxFlexFill>
        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastroDadosAcao.invalid || formCadastro.invalid" (click)="cadastrar()"> Cadastrar
        </button>

        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" 
                mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" 
                [disabled]="formCadastroDadosAcao.invalid || formCadastro.invalid" 
                (click)="atualizar()">
            Atualizar
        </button>

        <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
            Limpar
        </button>
        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
            Cancelar
        </button>

    </div>
</div>
